export default "__VITE_ASSET__Fcwkv9jP__ 584w";